<template>
	<div class="pui-form">
		<pui-form-header :showHeader="!isCreatingElement" v-if="modelLoaded">
			<imofalformsform-header v-model="model"></imofalformsform-header>
		</pui-form-header>
		<doc-new-version-modal :modelName="modelName" :pkAttribute="pkAttribute"></doc-new-version-modal>
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-tabs v-model="tabmodel" class="ml-3 mb-3" slider-color="primary">
				<v-tab :key="0" :href="'#imofalform2menu'">{{ $t('imofalform2menu.maintab') }}</v-tab>
				<v-tab v-if="!isCreatingElement" :key="1" :href="'#imofalform2tab'">{{ $t('imofalform2.maintab') }}</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tabmodel">
				<v-tab-item :key="0" lazy :value="'imofalform2menu'">
					<v-row class="pui-form-layout">
						<v-col xs12 lg12>
							<v-row dense>
								<v-col class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<pui-select
										v-if="!this.isCreatingElement"
										:id="`imofalform2menu-portcall`"
										attach="imofalform2menu-portcall"
										:label="$t('imofalform2menu.portcall')"
										disabled
										toplabel
										clearable
										v-model="model"
										:modelName="isCreatingElement ? 'vlupportcalls' : 'vlupportcalls'"
										:modelFormMapping="{ portcallid: 'portcallid' }"
										:itemsToSelect="[{ portcallid: model.portcallid }]"
										:itemValue="['portcallid']"
										:itemText="(item) => `${item.visitid}`"
										:order="{ portcallid: 'desc' }"
										:fixedFilter="filterPortcalls"
									></pui-select>
									<pui-select
										v-if="this.isCreatingElement"
										:id="`imofalform2menu-portcall`"
										attach="imofalform2menu-portcall"
										:label="$t('imofalform2menu.portcall')"
										:disabled="this.model.status == 'Submitted' || this.model.status == 'Invalid' || this.$route.params.parentpk"
										toplabel
										clearable
										v-model="model"
										modelName="vlupportcalls"
										:modelFormMapping="{ portcallid: 'portcallid' }"
										:itemsToSelect="[{ portcallid: model.portcallid }]"
										:itemValue="['portcallid']"
										:itemText="(item) => `${item.visitid}`"
										:order="{ portcallid: 'desc' }"
										:fixedFilter="filterPortcalls"
									></pui-select>
								</v-col>
								<v-col class="col-6 col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2" style="padding-top: 20px; margin-left: 50px">
								</v-col>
								<v-col class="col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="padding-top: 20px; margin-left: -50px">
									<v-radio-group
										v-if="this.isCreatingElement"
										v-model="model.indarrivaldeparture"
										:disabled="this.model.status == 'Submitted' || this.model.status == 'Invalid'"
										row
										style="position: relative; top: 4px"
									>
										<v-radio
											:label="$t('imofalform2menu.isarrival')"
											:checked="selectedOption === $t('imofalform2menu.isarrival')"
											:value="'1'"
										></v-radio>
										<v-radio
											:label="$t('imofalform2menu.isdeparture')"
											:checked="selectedOption === $t('imofalform2menu.isdeparture')"
											:value="'2'"
										></v-radio>
									</v-radio-group>
									<v-radio-group
										v-if="!this.isCreatingElement"
										v-model="model.indarrivaldeparture"
										disabled
										row
										style="position: relative; top: 4px"
									>
										<v-radio
											:label="$t('imofalform2menu.isarrival')"
											:checked="selectedOption === $t('imofalform2menu.isarrival')"
											:value="'1'"
										></v-radio>
										<v-radio
											:label="$t('imofalform2menu.isdeparture')"
											:checked="selectedOption === $t('imofalform2menu.isdeparture')"
											:value="'2'"
										></v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row dense style="margin-top: -15px">
								<v-col class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<pui-field-set :title="$t('menufieldset.ship')">
										<v-row dense>
											<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
												<pui-text-field
													:id="`imofalform2menu-shipname`"
													v-model="model.portcall.mship.shipname"
													:label="$t('imofalform2menu.shipname')"
													disabled
													toplabel
												></pui-text-field>
											</v-col>
											<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
												<pui-select
													id="`imofalform2menu-shiptype`"
													attach="imofalform2menu-shiptype"
													:label="$t('imofalform2menu.shiptype')"
													toplabel
													clearable
													disabled
													reactive
													v-model="model.portcall.mship"
													modelName="mshiptypes"
													:modelFormMapping="{ shiptypecode: 'shiptypecode' }"
													:itemsToSelect="itemsToSelectShipType"
													:itemValue="['shiptypecode']"
													:itemText="(item) => `${item.shiptypedesc}`"
													:order="{ shiptypedesc: 'asc' }"
												></pui-select>
											</v-col>

											<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
												<pui-text-field
													:id="`imofalform2menu-imo`"
													v-model="model.portcall.mship.imo"
													:label="$t('imofalform2menu.imo')"
													disabled
													toplabel
												></pui-text-field>
											</v-col>
											<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
												<pui-select
													id="`imofalform2menu-flag`"
													attach="imofalform2menu-flag"
													:label="$t('imofalform2menu.flag')"
													toplabel
													disabled
													clearable
													reactive
													v-model="model.portcall"
													modelName="mcountries"
													:modelFormMapping="{ countrycode: 'flag' }"
													:itemsToSelect="itemsToSelectFlag"
													:itemValue="['countrycode']"
													:itemText="(item) => `${item.countrycode}` + ` - ` + `${item.countrydesc}`"
													:order="{ countrydesc: 'asc' }"
												></pui-select>
											</v-col>
										</v-row>
									</pui-field-set>
								</v-col>
							</v-row>
							<v-row dense style="margin-top: -15px">
								<v-col class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<pui-field-set :title="$t('menufieldset.voyage')">
										<v-row dense>
											<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
												<pui-text-field
													:id="`imofalform2menu-voyagenum`"
													v-model="model.portcall.voyagenum"
													:label="$t('imofalform2menu.voyagenum')"
													disabled
													toplabel
												></pui-text-field>
											</v-col>
											<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
												<pui-select
													id="`imofalform2menu-portofarrival`"
													attach="imofalform2menu-portofarrival"
													:label="this.labelportarrival"
													toplabel
													v-model="model.portcall"
													modelName="mports"
													disabled
													reactive
													:modelFormMapping="{ countrycode: 'countrycode', portcode: 'portcode' }"
													:itemsToSelect="itemsToSelectArrivalPort"
													:itemValue="['countrycode', 'portcode']"
													:itemText="(item) => `${item.locode} - ${item.portdescription}`"
													:order="{ locode: 'asc' }"
												></pui-select>
											</v-col>

											<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" v-if="this.isCreatingElement">
												<pui-text-field
													:id="`imofalform2menu-mastername`"
													v-model="model.portcall.mastername"
													:label="$t('imofalform2menu.mastername')"
													:disabled="!this.isCreatingElement && this.model.statusid != '1'"
													toplabel
													@input="updateMastername($event)"
												></pui-text-field>
											</v-col>
											<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" v-else>
												<pui-text-field
													:id="`imofalform2menu-mastername`"
													v-model="model.mastername"
													:label="$t('imofalform2menu.mastername')"
													:disabled="this.model.statusid != '1'"
													toplabel
													@input="updateMastername($event)"
												></pui-text-field>
											</v-col>
											<!-- NMSWG-1554. Nuevos campos loadingport y loadingcountry en formulario y BD -->
											<v-col
												v-if="this.model.indarrivaldeparture === '1' && !this.isCreatingElement"
												class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
											>
												<pui-select
													id="`imofalform2menu-loadingport`"
													attach="imofalform2menu-loadingport"
													:label="$t('imofalform2menu.loadingport')"
													toplabel
													v-model="model"
													modelName="mports"
													:disabled="this.model.statusid != '1'"
													reactive
													:modelFormMapping="{ countrycode: 'loadingcountry', portcode: 'loadingport' }"
													:itemsToSelect="itemToSelectlastloadingPortFF2"
													:itemValue="['countrycode', 'portcode']"
													:itemText="(item) => `${item.locode} - ${item.portdescription}`"
													:order="{ locode: 'asc' }"
												></pui-select>
											</v-col>
											<v-col
												class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
												v-if="this.model.indarrivaldeparture === '1' && this.isCreatingElement"
											>
												<pui-select
													id="`imofalform2menu-loadingportPortcall`"
													attach="imofalform2menu-loadingportPortcall"
													:label="$t('imofalform2menu.loadingport')"
													toplabel
													v-model="model.portcall"
													modelName="mports"
													reactive
													:modelFormMapping="{ countrycode: 'lastloadingcountry', portcode: 'lastloadingport' }"
													:itemsToSelect="itemToSelectlastloadingPort"
													:itemValue="['countrycode', 'portcode']"
													:itemText="(item) => `${item.locode} - ${item.portdescription}`"
													:order="{ locode: 'asc' }"
													@change="updateLoadingPort($event)"
												></pui-select>
											</v-col>

											<!-- NMSWG-1554. Nuevos campos dischargeport y dischargeport en formulario y BD -->
											<v-col
												v-if="this.model.indarrivaldeparture === '2' && !this.isCreatingElement"
												class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
											>
												<pui-select
													id="`imofalform2menu-dischargeport`"
													attach="imofalform2menu-dischargeport"
													:label="$t('imofalform2menu.lastport')"
													toplabel
													v-model="model"
													modelName="mports"
													:disabled="this.model.statusid != '1'"
													reactive
													:modelFormMapping="{ countrycode: 'dischargecountry', portcode: 'dischargeport' }"
													:itemsToSelect="itemToSelectlastDischargePortFF2"
													:itemValue="['countrycode', 'portcode']"
													:itemText="(item) => `${item.locode} - ${item.portdescription}`"
													:order="{ locode: 'asc' }"
												></pui-select>
											</v-col>
											<v-col
												class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
												v-if="this.model.indarrivaldeparture === '2' && this.isCreatingElement"
											>
												<pui-select
													id="`imofalform2menu-loadingportPortcall`"
													attach="imofalform2menu-loadingportPortcall"
													:label="$t('imofalform2menu.lastport')"
													toplabel
													v-model="model.portcall"
													modelName="mports"
													reactive
													:modelFormMapping="{ countrycode: 'nextcountry', portcode: 'nextport' }"
													:itemsToSelect="itemToSelectlastDischargePort"
													:itemValue="['countrycode', 'portcode']"
													:itemText="(item) => `${item.locode} - ${item.portdescription}`"
													:order="{ locode: 'asc' }"
													@change="updateDischargePort($event)"
												></pui-select>
											</v-col>
										</v-row>
									</pui-field-set>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-tab-item>
				<v-tab-item :key="1" :value="'imofalform2tab'" lazy v-if="!isCreatingElement">
					<pui-master-detail
						componentName="imofalform2-grid"
						:parentModelName="modelName"
						:parentPk="pk"
						:parentPkChildFk="{ imofalformid: 'imofalformid' }"
						:parentModel="model"
						:formDisabled="this.model.status === this.statusSubmitted || this.model.status === 'Invalid'"
					></pui-master-detail>
				</v-tab-item>
			</v-tabs-items>
			<pui-form-footer>
				<nsw-imo-form-footer-btns
					:formDisabled="(this.model.status == 'Invalid' && !isCreatingElement) || !havePermissions(['WRITE_IMOFALFORM2'])"
					:saveDisabled="saving"
					:value="model"
					:saveAndUpdate="saveAndUpdate"
					:showNext="isCreatingElement"
					:showDraft="!isCreatingElement && this.model.status !== this.statusSubmitted"
					:showSubmit="!isCreatingElement && this.model.status !== this.statusSubmitted"
					:showNewVersion="false"
					modelName="imofalform2menu"
					:save="save"
					:back="back"
				></nsw-imo-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from '@Pui9Mixins/PuiFormMethodsMixin';
import { STATUS_SUBMITTED_DESC } from '../../constants/imofalforms/ImoFalFormsConstants';
import imofalform2Actions from './ImoFalForm2Actions';
import docNewVersionModal from '@/components/nsw-components/DocumentNewVersionModal';

export default {
	name: 'imofalform2menuform',
	mixins: [PuiFormMethodsMixin],
	components: {
		DocNewVersionModal: docNewVersionModal
	},
	data() {
		return {
			modelName: 'imofalform2menu',
			actions: imofalform2Actions.actions,
			pkAttribute: 'imofalformid',
			tabmodel: 'imofalform2menu',
			labelportarrival: this.$t('imofalform2menu.portofarrival'),
			statusSubmitted: STATUS_SUBMITTED_DESC,
			filtrado: ''
		};
	},
	mounted() {
		this.$puiEvents.$on('onPuiSelect_selectedItems-imofalform2menu-portcall', (newVal) => {
			var lupaModel = newVal.model;
			if (this.isCreatingElement) {
				if (lupaModel !== null) {
					this.fillPortCallFields2(lupaModel);
				} else {
					this.clearPortCallFields(lupaModel);
				}
			} else {
				if (lupaModel !== null) {
					this.fillPortCallFields(lupaModel);
				} else {
					this.clearPortCallFields(lupaModel);
				}
			}
		});
	},
	computed: {
		filterPortcalls() {
			return {
				groups: [
					{
						groupOp: 'and',
						rules: [
							{ field: 'portcallstatus', op: 'ne', data: 0 },
							{ field: 'portcallstatus', op: 'ne', data: 6 },
							{ field: 'portcallstatus', op: 'ne', data: 3 }
						]
					}
				]
			};
		},
		itemsToSelectShipType() {
			return [{ shiptypecode: this.model.portcall.mship.shiptypecode }];
		},
		itemsToSelectArrivalPort() {
			return [{ countrycode: this.model.portcall.countrycode, portcode: this.model.portcall.portcode }];
		},
		itemsToSelectFlag() {
			return [{ countrycode: this.model.portcall.mship.flag }];
		},
		itemToSelectPreviousPort() {
			return [{ countrycode: this.model.portcall.previouscountry, portcode: this.model.portcall.previousport }];
		},
		// NMSWG-1554. Nuevos campos loadingport y loadingcountry en formulario y BD
		itemToSelectlastloadingPort() {
			return [{ countrycode: this.model.portcall.lastloadingcountry, portcode: this.model.portcall.lastloadingport }];
		},
		itemToSelectlastloadingPortFF2() {
			return [{ countrycode: this.model.loadingcountry, portcode: this.model.loadingport }];
		},
		// NMSWG-1554. Nuevos campos dischargeport y dischargecountry en formulario y BD
		itemToSelectlastDischargePort() {
			return [{ countrycode: this.model.portcall.nextcountry, portcode: this.model.portcall.nextport }];
		},
		itemToSelectlastDischargePortFF2() {
			return [{ countrycode: this.model.dischargecountry, portcode: this.model.dischargeport }];
		}
	},
	watch: {
		'model.isarrival'() {
			if (this.model.isarrival === '1') {
				this.model.isdeparture = '0';
				this.model.indarrivaldeparture = '1';
				this.labelportarrival = this.$t('imofalform2menu.portofarrival');
			}
		},

		'model.isdeparture'() {
			if (this.model.isdeparture === '1') {
				this.model.isarrival = '0';
				this.model.indarrivaldeparture = '2';
				this.labelportarrival = this.$t('imofalform2menu.portofdeparture');
			}
		},
		// NMSWG-1554. Nuevos campos loadingport y loadingcountry en formulario y BD
		'model.portcall.lastloadingcountry'() {
			if (this.model.loadingport == null) {
				this.model.loadingport = this.model.portcall.lastloadingport;
				this.model.loadingcountry = this.model.portcall.lastloadingcountry;
			}
		},
		// NMSWG-1554. Nuevos campos dischargecountry y dischargeport en formulario y BD
		'model.portcall.nextcountry'() {
			if (this.model.dischargecountry == null) {
				this.model.dischargeport = this.model.portcall.nextport;
				this.model.dischargecountry = this.model.portcall.nextcountry;
			}
		}
	},
	methods: {
		afterGetData() {
			if (this.$route.params.parentpk) {
				this.model.portcallid = JSON.parse(atob(this.$route.params.parentpk)).portcallid;
			}
			// NMSWG-1554. Nuevos campos loadingport y loadingcountry en formulario y BD
			if (this.model.loadingport != null) {
				this.model.portcall.lastloadingcountry = this.model.loadingcountry;
				this.model.portcall.lastloadingport = this.model.loadingport;
			}
			// NMSWG-1554. Nuevos campos dischargecountry y dischargeport en formulario y BD
			if (this.model.dischargeport != null) {
				this.model.portcall.nextcountry = this.model.dischargecountry;
				this.model.portcall.nextport = this.model.dischargeport;
			}
		},
		// NMSWG-1554. Nuevos campos loadingport y loadingcountry en formulario y BD
		updateLoadingPort(value) {
			this.model.loadingcountry = value.lastloadingcountry;
			this.model.loadingport = value.lastloadingport;
		},
		// NMSWG-1554. Nuevos campos dischargecountry y dischargeport en formulario y BD
		updateDischargePort(value) {
			this.model.dischargecountry = value.nextcountry;
			this.model.dischargeport = value.nextport;
		},
		havePermissions(permissions) {
			const allowedForms = this.$store.getters.getSession.functionalities;
			// Verificar si el usuario tiene permisos para todos los permisos especificados
			return permissions.every((permission) => allowedForms.includes(permission));
		},
		fillPortCallFields2(lupaModel) {
			this.model.portcall.mship.flag = lupaModel.flag;
			this.model.portcall.mship.shipname = lupaModel.shipname;
			this.model.portcall.mship.shiptypecode = lupaModel.shiptypecode;
			this.model.portcall.mship.imo = lupaModel.imo;
			this.model.portcall.mship.callsign = lupaModel.callsign;
			this.model.portcall.voyagenum = lupaModel.voyagenum;
			this.model.portcall.countrycode = lupaModel.countrycode;
			this.model.portcall.portcode = lupaModel.portcode;
			this.model.arrivaldate = lupaModel.ata !== null ? lupaModel.ata : lupaModel.eta;
			this.model.departuredate = lupaModel.atd !== null ? lupaModel.atd : lupaModel.etd;
			this.model.portcall.countrycode = lupaModel.countrycode;
			this.model.portcall.previouscountry = lupaModel.previouscountry;
			this.model.portcall.previousport = lupaModel.previousport;
			this.model.portcall.nextcountry = lupaModel.nextcountry;
			this.model.portcall.nextport = lupaModel.nextport;
			this.model.portcall.mastername = lupaModel.mastername;
			this.model.indarrivaldeparture = '1';
			this.model.portcall.mship.flag = lupaModel.flag;
			this.model.portcall.lastloadingcountry = lupaModel.lastloadingcountry;
			this.model.portcall.lastloadingport = lupaModel.lastloadingport;
		},
		fillPortCallFields(lupaModel) {
			this.model.portcall.mship.shipname = lupaModel.shipname;
			this.model.portcall.mship.shiptypecode = lupaModel.shiptypecode;
			this.model.portcall.mship.imo = lupaModel.imo;
			this.model.portcall.mship.callsign = lupaModel.callsign;
			this.model.portcall.voyagenum = lupaModel.voyagenum;
			this.model.portcall.countrycode = lupaModel.countrycode;
			this.model.portcall.portcode = lupaModel.portcode;
			this.model.arrivaldate = lupaModel.ata !== null ? lupaModel.ata : lupaModel.eta;
			this.model.departuredate = lupaModel.atd !== null ? lupaModel.atd : lupaModel.etd;
			this.model.portcall.countrycode = lupaModel.countrycode;
			this.model.portcall.previouscountry = lupaModel.previouscountry;
			this.model.portcall.previousport = lupaModel.previousport;
			this.model.portcall.nextcountry = lupaModel.nextcountry;
			this.model.portcall.nextport = lupaModel.nextport;
			this.model.portcall.mastername = lupaModel.mastername;
			this.model.portcall.mship.flag = lupaModel.flag;
			this.model.portcall.lastloadingcountry = lupaModel.lastloadingcountry;
			this.model.portcall.lastloadingport = lupaModel.lastloadingport;
		},
		clearPortCallFields() {
			this.model.portcall.mship.flag = null;
			this.model.portcall.mship.shipname = null;
			this.model.portcall.mship.shiptypecode = null;
			this.model.portcall.mship.imo = null;
			this.model.portcall.mship.callsign = null;
			this.model.portcall.voyagenum = null;
			this.model.portcall.countryofarrival = null;
			this.model.portcall.countryofdeparture = null;
			this.model.portcall.portofarrival = null;
			this.model.portcall.portofdeparture = null;
			this.model.arrivaldate = null;
			this.model.departuredate = null;
			this.model.portcall.countrycode = null;
			this.model.portcall.portcode = null;
			this.model.portcall.previouscountry = null;
			this.model.portcall.previousport = null;
			this.model.portcall.nextcountry = null;
			this.model.portcall.nextport = null;
			this.model.portcall.mastername = null;
			this.model.portcall.lastloadingcountry = null;
			this.model.portcall.lastloadingport = null;
		}
	},
	destroyed() {
		this.$puiEvents.$off('onPuiSelect_selectedItems-imofalform2menu-portcall');
	}
};
</script>
